import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './containers/App/App';
import registerServiceWorker from './registerServiceWorker';

const root = createRoot(document.getElementById('root'));
root.render(<App />);
registerServiceWorker();
